<template lang="pug">
  .b2b-table-issues
    //- Filtro Tabla Issues
    b2b-filters-issues(:filter-options='options' @updateIssues="refreshIssues")
    //- Tabla de Issues
    ods-table(
      v-loading="loading"
      :data='issues.tableData',
      :start-sort='{ prop: "creationDateTime", order: "descending"}',
      style='width: 100%',
      @sort-change="orderOnServer",
      @selection-change='handleSelectionChange',
      highlight-current-row,
      size='small',
      fit)
      ods-table-column(
        type='selection',
        width='55')
      ods-table-column(
        prop='projectName',
        :label='$t("invoices.invoices_entity_table.project")',
        :show-overflow-tooltip='true',
        v-if='isShowServicioIssue',
        sortable='')
      ods-table-column(
        prop='sellerName',
        :label='$t("invoices.invoices_entity_table.seller")',
        :show-overflow-tooltip='true',
        v-if='isShowVendedorIssue',
        sortable='')
      ods-table-column(
        prop='buyerName',
        :label='$t("invoices.invoices_entity_table.buyer")',
        :show-overflow-tooltip='true',
        v-if='isShowCompradorIssue',
        sortable='')
      ods-table-column(
        prop='summary',
        :label='$t("issues.filters.subject.value")',
        :show-overflow-tooltip='true',
        v-if='isShowAsuntoIssue',
        sortable='')
      ods-table-column(
        prop='creationDateTime',
        :label='$t("invoices.invoices_entity_table.creation_date")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowFechaRegistroIssue',
        :formatter='formatterDate',
        sortable='')
      ods-table-column(
        prop='status',
        :label='$t("invoices.invoices_entity_table.status")',
        v-if='isShowEstadoIssue',
        :formatter='formatterIssueStatus',
        sortable='')
      ods-table-column(
        prop='issueType',
        :label='$t("issues.filters.issue_type.value")',
        :show-overflow-tooltip='true',
        v-if='isShowTipoIssue',
        :formatter='formatterIssueType',
        sortable='')
      ods-table-column(
        prop='priority',
        :label='$t("issues.filters.priority.value")',
        :show-overflow-tooltip='true',
        v-if='isShowPrioridadIssue',
        :formatter='formatterIssuePriority',
        sortable='')
      ods-table-column(
        label,
        align='center',
        :render-header='renderHeaderActions',
        width='130')
        //- Accions
        template(slot-scope='scope' placement='center')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('invoices.tooltip.detail') }}
            ods-button(
              style=' padding-left: 0px; padding-right: 10px;'
              type='neutral'
              @click='handleGoDetail(scope.row)')
              ods-icon(name='search', size='16')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('documentation_detail.buttons.eraseDocument') }}
            ods-button(
              v-if='canDeleteIssue || canAdminIndra'
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral'
              @click='handleErase(scope.row)')
              ods-icon(name='delete', size='16')
    //- Paginación Tabla
    ods-row.b2b-table-issues__pagination(v-if='issues.totalIssues > 0')
      ods-col.b2b-table-issues__pagination--right(:span='24')
        div.block(style='margin-bottom: 50px;')
          ods-pagination(
            ref='pagination',
            popper-class='b2b-pagination__dropdown',
            @size-change='handleSizeChange',
            @current-change='handleCurrentChangePagination',
            :current-page.sync='currentPage',
            :page-sizes='[20, 50, 100]',
            :page-size='20',
            layout='total, sizes, prev, pager, next, slot',
            :total='issues.totalIssues')

    //- Issues Seleccionadas
    transition(
      name='slide',
      mode='out-in')
      b2b-table-select-rows(
        v-if='multipleSelection.length',
        :total-select='multipleSelection.length')
        div(slot='actions')

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bFiltersIssues from '@/views/issues/B2bFiltersIssues'
import B2bTableMenuIssues from '@/views/issues/B2bTableMenuIssues'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import filters from './filtros-issues'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-table-issues',
  mixins: [Utils],
  data () {
    return {
      // Tabla
      currentRow: {},
      multipleSelection: [],
      multipleSelectionIds: [],
      // Paginación
      currentPage: null,
      loading: false,
      project: null
    }
  },

  computed: {
    ...mapGetters([
      'issues',
      'queryIssues',
      'isShowCompradorIssue',
      'isShowFechaRegistroIssue',
      'isShowEstadoIssue',
      'isShowVendedorIssue',
      'isShowServicioIssue',
      'isShowAsuntoIssue',
      'isShowPrioridadIssue',
      'isShowTipoIssue',
      'optionsFilterService',
      // Permisos
      'canAdminIndra',
      'canDeleteIssue',
      'urlIn'
    ])
  },

  components: {
    B2bFiltersIssues,
    B2bTableMenuIssues,
    B2bTableSelectRows
  },

  methods: {
    refreshIssues () {
      this.loading = true
      this.$forceUpdate()
      setTimeout(() => this.loading = false, 2000) // eslint-disable-line
    },
    ...mapActions([
      'getOptionsService',
      'getIssues',
      'queryIssuesState',
      'selectIssue',
      'deleteIssue',
      'optionsFilterServiceState'
    ]),

    // Ordenar Tabla
    async orderOnServer ({ column, order, prop }) {
      let stringSort = ''
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.order_table')
      })

      if (order === 'descending') {
        order = 'DESC'
      } else if (order === 'ascending') {
        order = 'ASC'
      } else {
        order = 'ASC'
      }

      if (!prop) {
        prop = 'creationDateTime'
      } else {
        switch (prop) {
          case 'buyerName':
            prop = 'partyByIdBuyer.tradeName'
            break
          case 'sellerName':
            prop = 'partyByIdSeller.tradeName'
            break
          case 'status':
            prop = 'issueStatus.status'
            break
        }
      }

      stringSort = prop + ',' + order
      this.queryIssues.sort = stringSort

      try {
        if (this.urlIn && this.urlIn !== 'b2b') {
          this.queryIssues.urlName = this.urlIn
        } else {
          this.queryIssues.urlName = null
        }
        await this.queryIssuesState(this.queryIssues)
        dataQuery.query = this.queryIssues
        const issues = await this.getIssues(dataQuery)
        console.log('ISSUES:::: ', issues)
      } catch (error) {
        console.log('orderOnServer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Conseguir datos de la fila en el hover del ratón
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },

    // Selección de Filas con el checkbox
    handleSelectionChange (val) {
      this.multipleSelection = val
      if (val.length === 0) {
        this.multipleSelection = []
      }
      this.multipleSelectionIds = this.multipleSelection.map(item => item.id)
    },

    // Ir al detalle
    handleGoDetail (issue) {
      this.handleCellMouseEnter(issue)
      this.selectIssue(issue)
      sessionStorage.setItem('summary', this.currentRow.summary)
      router.push({
        name: 'issue-detail',
        params: {
          issueId: this.currentRow.id,
          summary: this.currentRow.summary
        }
      })
    },
    // Formatear estado de la incidencia
    formatterIssueStatus (row, column) {
      return this.$t('issue.status.' + row[column.property])
    },
    // Formatear tipo de la incidencia
    formatterIssueType (row, column) {
      return this.$t('issue.type.' + row[column.property])
    },
    // Formatear estado de la incidencia
    formatterIssuePriority (row, column) {
      return this.$t('issue.priority.value_' + row[column.property])
    },
    // Formatear fechas Tabla
    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        if (column.property === 'creationDateTime') { return date.format(this.$t('date_format_long')) } else { return date.format(this.$t('date_format')) }
      } else {
        return this.$t('msg_generics.no_date')
      }
    },
    // JSX Menu Tabla
    renderHeaderActions: h => {
      return <B2bTableMenuIssues />
    },

    // Tamaño Tabla (20,50,100)
    async handleSizeChange (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.size_table')
      })
      try {
        const dataQuery = { query: {} }
        this.queryIssues.size = val
        if (this.urlIn && this.urlIn !== 'b2b') {
          this.queryIssues.urlName = this.urlIn
        } else {
          this.queryIssues.urlName = null
        }
        await this.queryIssuesState(this.queryIssues)
        dataQuery.query = this.queryIssues
        await this.getIssues(dataQuery)
      } catch (error) {
        console.log('handleSizeChange CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Paginacion
    async handleCurrentChangePagination (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.pagination_table')
      })

      try {
        const dataQuery = { query: {} }
        this.queryIssues.page = val - 1
        if (this.urlIn && this.urlIn !== 'b2b') {
          this.queryIssues.urlName = this.urlIn
        } else {
          this.queryIssues.urlName = null
        }
        await this.queryIssuesState(this.queryIssues)
        dataQuery.query = this.queryIssues
        const issues = await this.getIssues(dataQuery)
        console.log('ISSUES:::: ', issues)
      } catch (error) {
        console.log('handleCurrentChangePagination CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async handleErase (row) {
      this.$confirm(this.$t('issues.confirm.title_delete'), {
        confirmButtonText: this.$t('issues.confirm.confirm_button_delete'),
        showCancelButton: false,
        center: true,
        iconClass: 'ods-icon-warning'
      }).then(async () => {
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.issues_load_delete')
        })
        try {
          await this.deleteIssue(row.id)
          this.$notify({
            title: this.$t('issues.notify.delete_ok'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
          this.getTableContent()
        } catch (error) {
          console.log('handleErase CATCH: ', error)
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }).catch(() => {})
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error ? error.status : 0
      switch (statusCode) {
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
        case 400:
        case 500:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        case 409:
          errorSms = error.data.message
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      let errorArgList = []

      errorArgList = error.data.errorArgList
      console.log('--> errorArgList ', errorArgList)
      if (errorArgList && errorArgList[0].messageCode !== null) {
        for (let i = 0; i < errorArgList.length; i++) {
          const fullMessage = errorArgList[i].messageCode
          if (errorArgList[i].arguments === 'Ok.') {
            console.log('--> fullMessage ', fullMessage)
            console.log('--> fullMessage ', fullMessage.indexOf('se ha actualizado correctamente'))
          }
          if (errorArgList[i].arguments === 'Warn.') {
            await this.$notify({
              title: fullMessage,
              type: 'warning',
              position: 'top-right',
              customClass: 'b2b-notification-info',
              duration: 60000
            })
          } else {
            await this.$notify({
              title: fullMessage,
              type: 'error',
              position: 'top-right',
              customClass: 'b2b-notification-error',
              duration: 60000
            })
          }
        }
      } else {
        this.showNotificationError(error)
      }
    },

    async getTableContent () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        const dataQuery = { query: {} }
        this.options = filters.filters

        const dataQueryProj = { page: 0, size: 1000, sort: 'name,ASC', isSender: true }
        const optionsFilterService = await this.getOptionsService(dataQueryProj)
        await this.optionsFilterServiceState(optionsFilterService)

        if (optionsFilterService.length === 1) {
          this.queryIssues.projectId = optionsFilterService[0].id
        }
        this.currentPage = this.queryIssues.page + 1
        if (this.urlIn && this.urlIn !== 'b2b') {
          this.queryIssues.urlName = this.urlIn
        } else {
          this.queryIssues.urlName = null
        }
        dataQuery.query = this.queryIssues
        await this.getIssues(dataQuery)
      } catch (error) {
        console.log('getDocumentation CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    }
  },

  async created () {
    await this.getTableContent()
  }
}
</script>

<style lang="scss" scoped>
.b2b-table-issues {
  ::v-deep .ods-table {
    th {
      padding: rem(0);
      padding-top: rem(4);
      .cell {
        font-weight: 500;
      }
      .ods-dropdown{
        padding-left: 0px;
        padding-right: 0px;
      }

      &:last-child {
        padding-top: rem(0);
        .cell {
          .ods-dropdown {
            line-height: 32px;
          }
        }
      }
      .cell:last-child {
        .ods-dropdown {
          line-height: 32px;
        }
      }
    }
    &__row {
      .cell {
        .text-overflow-tooltip {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .ods-button {
        padding: rem(1) rem(15) rem(0) rem(15);
        margin-left: rem(0);
        margin-right: rem(0);
        i {
          margin-left: rem(0);
        }
      }
    }
  }

  ::v-deep &__pagination {
    margin: rem(32) rem(24) rem(32) rem(24);
    &--left {
      .ods-button {
        font-size: 0.625rem;
        line-height: 1.4;
        letter-spacing: .04rem;
        text-align: center;
        i {
          &:before {
            font-size: 0.625rem;
          }
        }
      }
    }
    &--right {
      .block {
        float: right;
      }
    }
  }
}
</style>
<style lang="scss">
  .ods-notification {
    width: 450px!important;
  }
  .ods-popover {
    margin-right: 15px;
  }
</style>
